import React, { Component } from 'react';
import { withRouter } from 'react-router';
import './SettingsMenu.scss';
import { Link } from 'react-router-dom';
import { historyShape, locationShape } from '../../../utils/propTypes';
import classNames from 'classnames';

export class SettingsMenu extends Component {
    static propTypes = {
        history: historyShape,
        location: locationShape
    };

    render() {
        const emvioSettingsMenuClasses = classNames('emvio-settings-menu', { display: this.props.location.pathname === '/settings' });

        return (
            <div className={emvioSettingsMenuClasses}>
                <div className="settings-menu-modal">
                    <div onClick={this.props.history.goBack} className="settings-menu-header">
                        <div className="icon">close</div>
                        <div className="text">Settings</div>
                    </div>
                    <div className="settings-nav-container">
                        <div className="settings-nav">
                            <Link to="/settings/details" className="settings-nav-link">
                                <div className="icon-text">
                                    <div className="icon">account_circle</div>
                                    <div className="text">User Details</div>
                                </div>
                                <div className="arrow">navigate_next</div>
                            </Link>
                            <Link to="/settings/notifications" className="settings-nav-link">
                                <div className="icon-text">
                                    <div className="icon">notifications_active</div>
                                    <div className="text">Notifications</div>
                                </div>
                                <div className="arrow">navigate_next</div>
                            </Link>
                            <Link to="/settings/userManagement" className="settings-nav-link">
                                <div className="icon-text">
                                    <div className="icon">supervised_user_circle</div>
                                    <div className="text">User Management</div>
                                </div>
                                <div className="arrow">navigate_next</div>
                            </Link>
                            <Link to="/settings/merchantManagement" className="settings-nav-link">
                                <div className="icon-text">
                                    <div className="icon">corporate_fare</div>
                                    <div className="text">Merchant Management</div>
                                </div>
                                <div className="arrow">navigate_next</div>
                            </Link>
                            <Link to="/settings/routeManagement" className="settings-nav-link">
                                <div className="icon-text">
                                    <div className="icon">open_with</div>
                                    <div className="text">Routing Rules</div>
                                </div>
                                <div className="arrow">navigate_next</div>
                            </Link>
                            <Link to="/settings/webhookLog" className="settings-nav-link">
                                <div className="icon-text">
                                    <div className="icon">sync_alt</div>
                                    <div className="text">Webhook Log</div>
                                </div>
                                <div className="arrow">navigate_next</div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(SettingsMenu);
